'use client'

import { FieldMappingPanel } from '@repo/formevo-configuration/FieldMappingPanel'
import { SettingsPanel } from '@repo/formevo-configuration/SettingsPanel'
import { WorktypeLinkingPanel } from '@repo/formevo-configuration/WorktypeLinkingPanel'
import { useEffect, useRef, useState } from 'react'
import { RefreshIcon } from '@repo/ui/RefreshIcon'
import { useThirdPartyFormsStore } from '@repo/store/useThirdPartyFormsStore'
import MUIButton from '@mui/material/Button'
import MUICircularProgress from '@mui/material/CircularProgress'
import MUIStack from '@mui/material/Stack'
import MUITab from '@mui/material/Tab'
import MUITabs from '@mui/material/Tabs'

const TABS = {
  settings: 'settings',
  worktypeLinking: 'worktypeLinking',
  fieldMapping: 'fieldMapping'
}

export const FormEvoConfigurationModule = () => {
  const [selectedTab, setSelectedTab] = useState(TABS.settings)
  const [isRefreshingForms, setIsRefreshingForms] = useState(false)
  const { refreshOsprey2FormsAndFormCategories } = useThirdPartyFormsStore()

  const isMountedRef = useRef(true)
  useEffect(() => {
    isMountedRef.current = true
    return () => {
      isMountedRef.current = false
    }
  }, [])

  const handleRefreshForms = async () => {
    setIsRefreshingForms(true)
    try {
      await refreshOsprey2FormsAndFormCategories()
    } catch (error) {
      console.error('Error refreshing forms from FormEvo:', error)
    } finally {
      if (isMountedRef.current) setIsRefreshingForms(false)
    }
  }

  return (
    <MUIStack data-testid="FormEvoConfigurationModule" gap={4}>
      <MUIStack direction="row" justifyContent="space-between" alignItems="center" sx={{ mr: '4rem' }}>
        <MUITabs
          value={selectedTab}
          onChange={(_, value) => setSelectedTab(value)}
          sx={{
            ml: '4rem',
            borderBottom: 'none',
            '& .MuiTabs-flexContainer': {
              borderBottom: 'none'
            }
          }}
        >
          <MUITab value={TABS.settings} label="Settings" />
          <MUITab value={TABS.worktypeLinking} label="Worktype linking" />
          <MUITab value={TABS.fieldMapping} label="Field mapping" />
        </MUITabs>

        <MUIButton
          data-testid="FormEvoRefreshFormsButton"
          variant="outlined"
          startIcon={isRefreshingForms ? <MUICircularProgress size={16} color="inherit" /> : <RefreshIcon />}
          onClick={handleRefreshForms}
        >
          Refresh forms
        </MUIButton>
      </MUIStack>

      {selectedTab === TABS.settings && <SettingsPanel />}
      {selectedTab === TABS.worktypeLinking && <WorktypeLinkingPanel />}
      {selectedTab === TABS.fieldMapping && <FieldMappingPanel />}
    </MUIStack>
  )
}
